import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { toLight: "Activar modo claro", toDark: "Activar modo oscuro", light: "Modo claro", dark: "Modo oscuro" },
  en: { toLight: "Switch to light mode", toDark: "Switch to dark mode", light: "Light mode", dark: "Dark mode" },
});
